import http from '../../http'

const API_URL = "acpm-documents"

/** Ítem 7.1.2 — Documentos ACPM diligenciados por la empresa (subida libre). */
class AcpmDocumentAPI {

  async getAll(companyId, page = 1, search = "") {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}&search=${search}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }
}

export default new AcpmDocumentAPI()
